import styled from '@emotion/styled';
import { COLORS } from '../../../utils/colors';
import { Typography, Button, Box } from '@mui/material';

export const useManageReportStyles = () => {
  return {
    uploadProgressWrapper: {
      p: '1.125rem 1.625rem',
      borderRadius: '.9375rem',
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      bgcolor: 'transparent',
    },
    uploadProgress: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      height: '100%',
      maxWidth: '100%',
      borderTopLeftRadius: '.75rem',
      borderBottomLeftRadius: '.75rem',
      opacity: 0.15,
      transition: 'ease-in',
    },
    cancelUpload: {
      zIndex: 2,
      bgcolor: COLORS.TOAST_ERROR,
      '&:hover': {
        bgcolor: COLORS.TOAST_ERROR,
        transform: 'scale(1.03)',
      },
    },
    cancelUploadIcon: { color: COLORS.RED, fontSize: '24px' },
    closeButton: {
      cursor: 'pointer',
      textDecoration: 'none',
      color: 'inherit',
      padding: 0,
      height: 0,
    },
    sendReport: {
      textTransform: 'none',
      fontSize: '.75rem',
      my: '2rem',
    },
    deleteReportButton: {
      position: 'absolute',
      bgcolor: 'white',
      top: '.625rem',
      right: '.625rem',
      color: 'black',
      zIndex: 99,
      '&:hover': {
        bgcolor: 'white',
        transform: 'scale(1.03)',
      },
    },
  };
};

export const StyledSubText = styled(Typography)({
  fontWeight: 500,
});

export const StyledDetailsHeading = styled(Typography)({
  fontSize: '12px',
  fontWeight: 'bold',
});

export const StyledButton = styled(Button)({
  borderRadius: '1rem',
  color: COLORS.BACKGROUND,
  fontWeight: 500,
  textTransform: 'none',
  marginBottom: '1.5rem',
  minWidth: '12rem',
});

export const StyledReportOverlay = styled(Box)({
  position: 'absolute',
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  color: 'white',
  background: 'rgba(0, 0, 0, 0.4)',
  opacity: 0,
  transition: 'opacity 0.3s ease',
  borderRadius: '1.125rem',
  cursor: 'pointer',
  zIndex: 10,
  ':hover': {
    opacity: 1,
  },
});
